import { InitialDates } from '../../_components/molecules/NewEditDuration';
import { EmployerGroupResponseData } from '../../pages/HomePage';
import { getLatestDate } from './helper';

export interface Reports {
  id: string;
  name: string;
  downloadFrequency: string;
}

export interface EmployerGroups {
  id: string;
  name: string;
  eg_nid: string;
  lastUpdated: string;
  start_month: string;
  start_year: number;
  end_month: string;
  end_year: number;
  plan_start_month: string;
  plan_end_month: string;
  recent_plan_year: number;
}

export const allReports = [
  {
    id: 'summaryReport',
    name: 'Executive Summary',
    downloadFrequency: 'Annual',
  },
  {
    id: 'diseasePrevalenceReport',
    name: 'Disease Prevalence',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'chronicPrevalenceReport',
    name: 'Chronic Prevalence',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  // {
  //   id: 'riskReport',
  //   name: 'Disease Prognosis',
  //   downloadFrequency: 'Annual',
  // },
  {
    id: 'careQualityReport',
    name: 'Care Gaps',
    downloadFrequency: 'Annual',
  },
  {
    id: 'episodesOfCareReport',
    name: 'Episodes of Care',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'highCostReport',
    name: 'High Cost Claimants',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'stoplossAggregateReport',
    name: 'Stop Loss Aggregate Report',
    downloadFrequency: 'Annual',
  },
  {
    id: 'stopLossReport',
    name: 'Stop Loss Triggers',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'stoploss5050Report',
    name: '50-50 Report Plan',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'planPerformanceReport',
    name: 'Plan Performance',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'claimsReport',
    name: 'Claims Metrics',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'enrollmentReport',
    name: 'Enrollment Metrics',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'networkLeakageReport',
    name: 'Network Usage',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'rejectedClaimsReport',
    name: 'Rejected Claims',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'pendingClaimsReport',
    name: 'Pending Claims',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  // {
  //   id: 'utilizationSummaryReport',
  //   name: 'Utilization Summary',
  //   downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  // },
  {
    id: 'utilizationPatientReport',
    name: 'Admission Utilization',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'utilizationPharmacyReport',
    name: 'Pharmacy Utilization',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'utilizationProcedureReport',
    name: 'Procedure Utilization',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  {
    id: 'utilizationProviderReport',
    name: 'Provider Utilization',
    downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  },
  // {
  //   id: 'wasteCalculatorReport',
  //   name: 'Waste Calculator',
  //   downloadFrequency: 'Month, Quarter, Half-Year or Annual',
  // },
];

export const getAllEmployerGroups = (
  employerGroups: EmployerGroupResponseData[],
) => {
  const employers = employerGroups?.map((employer) => {
    return {
      id: employer.eg_nid,
      name: employer.employer_group_name,
      eg_nid: employer.eg_nid,
      lastUpdated: employer.last_updated,
      start_month: employer.start_month,
      start_year: employer.start_year,
      end_month: employer.end_month,
      end_year: employer.end_year,
      plan_start_month: employer.plan_start_month,
    };
  });

  return employers;
};
export const getEmployerGroup = (
  employerGroups: EmployerGroupResponseData[],
) => {
  const employers = employerGroups?.map((employer) => {
    return {
      id: employer.eg_nid[0],
      name: employer.employer_group_name[0],
      eg_nid: employer.eg_nid[0],
      lastUpdated: employer.last_updated,
      start_month: employer.start_month,
      start_year: employer.start_year,
      end_month: employer.end_month,
      end_year: employer.end_year,
      plan_start_month: employer.plan_start_month,
      plan_end_month: employer.plan_end_month,
      recent_plan_year: employer.recent_plan_year,
    };
  });

  return employers;
};
export const getEmployersDataFromIds = (
  employerIds: string[],
  allEmployerGroups: EmployerGroupResponseData[],
  isArray?: boolean,
) => {
  const employersData: any[] = [];
  allEmployerGroups?.map((employer) => {
    if (employerIds.includes(employer.eg_nid)) {
      employersData.push({
        id: employer.eg_nid,
        name: isArray
          ? [employer.employer_group_name]
          : employer.employer_group_name,
        eg_nid: isArray ? [employer.eg_nid] : employer.eg_nid,
        lastUpdated: employer.last_updated,
        start_month: employer.start_month,
        start_year: employer.start_year,
        end_month: employer.end_month,
        end_year: employer.end_year,
        plan_start_month: employer.plan_start_month,
      });
    }
  });

  return employersData;
};
export const getEmployersDataFromEmpName = (
  employerIds: string[],
  allEmployerGroups: EmployerGroupResponseData[],
) => {
  const employersData: any[] = [];
  allEmployerGroups?.map((employer) => {
    if (employerIds.includes(employer.employer_group_name)) {
      employersData.push({
        id: employer.eg_nid,
        name: employer.employer_group_name,
        eg_nid: employer.eg_nid,
        lastUpdated: employer.last_updated,
        start_month: employer.start_month,
        start_year: employer.start_year,
        end_month: employer.end_month,
        end_year: employer.end_year,
        plan_start_month: employer.plan_start_month,
      });
    }
  });

  return employersData;
};

export const getReportsDataFromIds = (reportIds: string[]) => {
  const reportsData: any[] = [];
  allReports?.map((report) => {
    if (reportIds.includes(report.id)) {
      reportsData.push({
        id: report.id,
        name: report.name,
        downloadFrequency: report.downloadFrequency,
      });
    }
  });
  return reportsData;
};

//function to get latest last_upated value among given employer group ids
export const getLastUpdatedForEmployerGroups = (
  employerIds: string[],
  allEmployerGroups: EmployerGroupResponseData[],
) => {
  const allLastUpatedValues: string[] = [];
  allEmployerGroups?.map((employer) => {
    if (employerIds.includes(employer.eg_nid)) {
      allLastUpatedValues.push(employer.last_updated);
    }
  });
  return getLatestDate(allLastUpatedValues);
};

//function to get plan periods from multiple employers, get minimum start date and maximum end date from all selected employer groups
export const getPlanPeriodDates = (
  employerGroups: EmployerGroups[],
): InitialDates => {
  let startYear: number = 0;
  let endYear: number = 0;
  const planPeriodDates: InitialDates = {
    start_month: '',
    end_month: '',
    plan_start_month: '',
    start_year: 0,
    end_year: 0,
    plan_end_month: '',
    recent_plan_year: 0,
  };

  employerGroups?.map((employer, index) => {
    if (index === 0) {
      startYear = employer.start_year;
      endYear = employer.end_year;
      planPeriodDates.start_month = employer.start_month;
      planPeriodDates.end_month = employer.end_month;
      planPeriodDates.plan_start_month = employer.plan_start_month;
      planPeriodDates.plan_end_month = employer.plan_end_month;
      planPeriodDates.recent_plan_year = employer.recent_plan_year;
    } else {
      if (employer.start_year < startYear) {
        startYear = employer.start_year;
      }
      if (employer.end_year > endYear) {
        endYear = employer.end_year;
      }
    }
  });
  planPeriodDates.start_year = startYear;
  planPeriodDates.end_year = endYear;
  return planPeriodDates;
};
